<mat-toolbar
  [dir]="frame?.rtlEnabled ? 'rtl' : 'auto'"
  color="primary"
  [ngClass]="{
    'toolbar-style': true,
    'detail-toolbar-style': this.frame.routing.getCurrentConfig().designation !== AppService.Route_ResourceList,
  }"
>
  @if (this.frame.routing.getCurrentConfig().designation === AppService.Route_ResourceList) {
    <span class="toolbar-header">{{ res.get('Resources') }}</span>
    <span class="toolbar-spacer"></span>
  } @else {
    <abcTileNavMenu>
      <tile (click)="this.resourcesService.navigateTo(AppService.Route_ResourceList)"> {{ res.get('Resources') }}</tile>
      @if (this.dataContext.navigationContext) {
        <tile>
          {{
            res.get(
              'Resources-RecordingOfRessourceEventOfType',
              this.dataContext.navigationContext.resourceEventGroup.resourceEventTypeGroup.resourceEventTypeKindName
            )
          }}</tile
        >
      }
    </abcTileNavMenu>
    <span class="toolbar-spacer"></span>
  }
  <button mat-icon-button class="toolBarButton" (click)="this.frame.lib.closeBottomSheet()">
    <mat-icon [svgIcon]="res.svgName('ExpandMore-Image')"></mat-icon>
  </button>
</mat-toolbar>
<!-- <div [@resourcesAnimation]="ViewModelHelper.getAnimationData(routerOutlet)" *ngIf="!dataSource.isEmpty; else noData"> -->
@if (!dataSource.isEmpty) {
  <div>
    <router-outlet name="resourcesRouterOutlet"></router-outlet>
  </div>
} @else {
  <div class="noDataPlaceHolder">&lt;{{ res.get('Resources-NoData') }}&gt;</div>
}
